import { Link, useLoaderData, useSubmit } from 'react-router-dom';
import type { ArticleDto } from '../application/dto/ArticleDto';
import './AdminArticleListPage.css';

export interface AdminArticleListLoaderData {
  heading: string;
  basePath: string;
  articles: ArticleDto[];
}

const STATUS_LABELS: Record<ArticleDto['status'], string> = {
  draft: 'پیش‌نویس',
  published: 'منتشرشده'
};

export function AdminArticleListPage() {
  const { heading, basePath, articles } = useLoaderData() as AdminArticleListLoaderData;
  const submit = useSubmit();

  function handleDelete(id: string, title: string) {
    const confirmed = window.confirm(`«${title}» حذف شود؟ این عملیات قابل بازگشت نیست.`);
    if (confirmed) {
      submit(null, { method: 'post', action: `${basePath}/${id}/delete` });
    }
  }

  return (
    <div className="dma-admin-article-list">
      <div className="dma-admin-article-list__header">
        <h1>{heading}</h1>
        <Link to={`${basePath}/new`} className="dma-admin-article-list__add">
          افزودن مطلب جدید
        </Link>
      </div>

      {articles.length === 0 ? (
        <p className="dma-admin-article-list__empty">هنوز مطلبی ثبت نشده است.</p>
      ) : (
        <table className="dma-admin-article-list__table">
          <thead>
            <tr>
              <th>عنوان</th>
              <th>وضعیت</th>
              <th>آخرین ویرایش</th>
              <th aria-hidden="true" />
            </tr>
          </thead>
          <tbody>
            {articles.map((article) => (
              <tr key={article.id}>
                <td>{article.title}</td>
                <td>
                  <span className={`dma-admin-article-list__status dma-admin-article-list__status--${article.status}`}>
                    {STATUS_LABELS[article.status]}
                  </span>
                </td>
                <td>{new Date(article.updatedAt).toLocaleDateString('fa-IR')}</td>
                <td className="dma-admin-article-list__actions">
                  <Link to={`${basePath}/${article.id}/edit`}>ویرایش</Link>
                  <button type="button" onClick={() => handleDelete(article.id, article.title)}>
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
